





import { Component, Vue } from "vue-property-decorator";
import md5 from "js-md5";
// import { raffleCollect } from "@/config/sdkCollect";
@Component({
  components: {},
})
export default class Invote extends Vue {
  public mounted() {
    /* raffleCollect(7, {
      pool_id: 1,
      pool_name: 1,
    }); */
    const cookieKey = document.cookie
      ? md5(JSON.stringify(document.cookie))
      : "";
    this.$fn.boxCollectChange("yaoqingzhuanqian_1241", {
      md5hash: cookieKey,
    });
  }
}
